import { Injectable } from '@angular/core';
import { RequestService } from '../requestService/request.service';

@Injectable({
  providedIn: 'root'
})
export class VPCService {
  vpcToken;
  interval;
  polling;
  // Video Playback Concurrency (VPC) service
  constructor(private requestService: RequestService) { }

  /** * Start VPC Process */
  lock(vpcToken, interval) {
    if (vpcToken) {
      this.vpcToken = vpcToken;
      this.interval = interval;
      clearInterval(this.polling);
      this.polling = setInterval(() => {
        this.update();
      }, this.interval * 1000);
    }
  }

  /** * Update VPC */
  update() {
    this.requestService.mainGetRequest({
      url: "/api/Vpc/update?vpcToken=" + this.vpcToken
    }).then((resp: any) => {
      this.vpcToken = resp.data.vpcToken;
      this.interval = resp.data.interval;
    });
  }

  /** * Unlock VPC */
  unlock() {
    return new Promise(resolve => {
      if (this.vpcToken) {
        clearInterval(this.polling);
        this.requestService.mainGetRequest({
          url: "/api/Vpc/unlock?vpcToken=" + this.vpcToken
        }).then(resp => {
          this.vpcToken = null;
          resolve(true);
        });
      } else {
        resolve(true);
      }
    });
  }
}